import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AdminLayout } from '@/features/Layout/AdminLayout';
import { RouteGuard } from '@/features/Auth/RouteGuard';
import { LoginPage } from '@/features/Auth/LoginPage';
import { DashboardPage } from '@/features/Dashboard/DashboardPage';
import { CompanyListPage } from '@/features/Companies/CompanyListPage';
import { CompanyDetailPage } from '@/features/Companies/CompanyDetailPage';
import { CompanyForm } from '@/features/Companies/CompanyForm';
import { DemoManagementPage } from '@/features/Companies/DemoManagementPage';
import { TokenSendPage } from '@/features/Tokens/TokenSendPage';
import { TokenHistoryPage } from '@/features/Tokens/TokenHistoryPage';
import { AutomationPage } from '@/features/Automation/AutomationPage';
import { RevenuePage } from '@/features/Revenue/RevenuePage';
import { ArchitecturePage } from '@/features/Architecture/ArchitecturePage';
import { CockpitPage } from '@/features/Cockpit/CockpitPage';
import { ModerationPage } from '@/features/Moderation/ModerationPage';
import { SettingsPage } from '@/features/Settings/SettingsPage';
import { WebsitePrintPage } from '@/features/WebsitePrint/WebsitePrintPage';
import { GoogleAdsAuditorPage, GoogleAdsOAuthCallback } from '@/features/GoogleAdsAuditor';

import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import 'mantine-datatable/styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 2,
    },
  },
});

export function App() {
  return (
    <MantineProvider defaultColorScheme="light">
      <Notifications position="top-right" />
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              element={
                <RouteGuard>
                  <AdminLayout />
                </RouteGuard>
              }
            >
              <Route index element={<DashboardPage />} />
              <Route path="companies" element={<CompanyListPage />} />
              <Route path="companies/new" element={<CompanyForm />} />
              <Route path="companies/:id" element={<CompanyDetailPage />} />
              <Route path="companies/:id/edit" element={<CompanyForm />} />
              <Route path="demos" element={<DemoManagementPage />} />
              <Route path="tokens" element={<TokenSendPage />} />
              <Route path="tokens/history" element={<TokenHistoryPage />} />
              <Route path="automation" element={<AutomationPage />} />
              <Route path="revenue" element={<RevenuePage />} />
              <Route path="moderation" element={<ModerationPage />} />
              <Route path="cockpit" element={<CockpitPage />} />
              <Route path="architecture" element={<ArchitecturePage />} />
              <Route path="website-print" element={<WebsitePrintPage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="google-ads-auditor" element={<GoogleAdsAuditorPage />} />
              <Route path="google-ads-auditor/oauth/callback" element={<GoogleAdsOAuthCallback />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </QueryClientProvider>
    </MantineProvider>
  );
}
